import { z } from 'zod';

import { idSchema, isoDateSchema, slugSchema } from './common.schema';

export const groupSchema = z.object({
  id: idSchema,
  workspace_id: idSchema,
  name: z.string().min(1).max(200),
  slug: slugSchema,
  description: z.string().max(1000).nullable().optional(),
  routing_key: z.string().max(255).nullable().optional(),
  member_ids: z.array(idSchema).optional(),
  created_at: isoDateSchema,
  updated_at: isoDateSchema,
});
export type Group = z.infer<typeof groupSchema>;

export const createGroupSchema = z.object({
  name: z.string().min(1).max(200),
  slug: slugSchema,
  description: z.string().max(1000).optional(),
  routing_key: z.string().max(255).optional(),
  member_ids: z.array(idSchema).optional(),
});

export const updateGroupSchema = createGroupSchema.partial();
